/* eslint-disable no-unused-vars */
import { all, call, put, take, takeLatest } from 'redux-saga/effects'

export function * serverLogin (action) {
  // make API call using saga, as shown below
  // const res = yield apiCall();
}
